if (!customElements.get('routine-section')) {
  class RoutineSection extends HTMLElement {
    constructor() {
      super();
      this.ctaButton = this.querySelector('[data-routine-cta]');
      this.confirmationEl = this.querySelector('.routine__confirmation');
      this.confirmationText = this.querySelector('[data-routine-confirmation-text]');
    }

    connectedCallback() {
      if (this.ctaButton) {
        this.ctaButton.addEventListener('click', this.onBundleAdd.bind(this));
      }
    }

    // Collect variant IDs from in-stock cards only.
    // Uses data-available="true" because product-form.js re-enables disabled inputs on init.
    // Includes properties._collectionIds so Shopify merges quantities with items added
    // individually via the per-card quick-add (same variant + same properties = merged, not duplicated).
    getVariantItems() {
      return Array.from(this.querySelectorAll('input.product-variant-id[data-available="true"]'))
        .map((input) => {
          const id = parseInt(input.value, 10);
          if (!id) return null;
          const item = { id, quantity: 1 };
          const collectionIds = input.dataset.collectionIds;
          if (collectionIds !== undefined) item.properties = { _collectionIds: collectionIds };
          return item;
        })
        .filter(Boolean);
    }

    showConfirmation(count) {
      if (!this.confirmationEl || !this.confirmationText) return;
      const template = this.confirmationEl.dataset.itemsAdded || '';
      this.confirmationText.textContent = template.replace('ROUTINE_COUNT', count);
      this.confirmationEl.removeAttribute('hidden');
    }

    setButtonState(loading) {
      this.ctaButton.disabled = loading;
      this.ctaButton.setAttribute('aria-busy', String(loading));
    }

    async onBundleAdd() {
      const items = this.getVariantItems();
      if (!items.length) return;

      // Look up cart element at call time, not constructor, to ensure it's in the DOM.
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      this.setButtonState(true);

      try {
        cart?.setActiveElement(document.activeElement);

        // Step 1: add items to cart via JSON.
        const addResponse = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        const addData = await addResponse.json();

        if (!addResponse.ok) {
          console.error('[routine-section] cart add error:', addData.description || addData);
          return;
        }

        this.showConfirmation(items.length);

        if (cart) {
          // Step 2: fetch fresh section HTML — guaranteed to reflect the cart state after the add.
          const sectionIds = cart
            .getSectionsToRender()
            .map((s) => s.id)
            .join(',');
          const sectionsResponse = await fetch(`${window.location.pathname}?sections=${sectionIds}`);

          if (!sectionsResponse.ok) {
            console.error('[routine-section] sections fetch error:', sectionsResponse.status);
            return;
          }

          const sections = await sectionsResponse.json();

          // Mirror product-form.js: remove is-empty before renderContents so the
          // drawer doesn't show the empty state when the cart was empty before this add.
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

          // renderContents updates the drawer HTML and calls open() internally.
          cart.renderContents({ sections, id: addData.items?.[0]?.id });
        } else {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'routine-section-bundle', cartData: addData });
        }
      } catch (err) {
        console.error('[routine-section] bundle add failed:', err);
      } finally {
        this.setButtonState(false);
      }
    }
  }

  customElements.define('routine-section', RoutineSection);
}
